module.exports = __webpack_public_path__ + "img/dots-small-double.add30f41.svg";